import React, { useState } from "react";
import usePuntosCategoriaSubcategoria from "../../../hooks/administrador/recoleccion/usePuntosGeneracion";
import EchartsWrapper from "../../../pages/EchartsWrapper";
import "../../../styles/administrador.css";

const PuntosCategoriaSubcategoria = ({
  year,
  mes,
  token,
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada,
}) => {
  const { data, loading, error } = usePuntosCategoriaSubcategoria(
    year,
    mes,
    token,
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  const [currentView, setCurrentView] = useState("main");
  const [selectedCategory, setSelectedCategory] = useState(null);

  if (loading) {
    return (
      <div className="grafica loading-container">
        <p>Cargando datos de puntos por categoría...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="grafica error-container">
        <p>Error: {error}</p>
      </div>
    );
  }

  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="grafica empty-container">
        <p>No hay datos disponibles para los filtros seleccionados.</p>
      </div>
    );
  }

  const categorias = {};
  const categoriasData = {};
  const cantidadPorCategoria = {};

  data.forEach((item) => {
    const categoria = item.Categoria || "Sin categoría";
    const subcategoria = item.SubCategoria || "Sin subcategoría";
    const cantidad = parseInt(item.Cantidad.replace(/,/g, "")) || 0;
    const puntos = parseInt(item.Puntos_Gestion) || 0;

    if (!categorias[categoria]) {
      categorias[categoria] = 0;
      categoriasData[categoria] = [];
      cantidadPorCategoria[categoria] = 0;
    }

    categorias[categoria] += puntos;
    cantidadPorCategoria[categoria] += cantidad;

    categoriasData[categoria].push({
      name: subcategoria,
      value: puntos,
      cantidad: cantidad,
    });
  });

  const mainSeriesData = Object.keys(categorias).map((categoria) => ({
    name: categoria,
    value: categorias[categoria],
    cantidad: cantidadPorCategoria[categoria],
    subcategorias: categoriasData[categoria],
  }));

  const totalPuntos = Object.values(categorias).reduce(
    (sum, count) => sum + count,
    0
  );
  const totalCantidad = Object.values(cantidadPorCategoria).reduce(
    (sum, count) => sum + count,
    0
  );

  const mainChartOptions = {
    title: {
      text: "Categoría por punto de generación",
      left: "center",
      subtext: `TOTAL DE PUNTOS: ${totalPuntos.toLocaleString()} | TOTAL NFU: ${totalCantidad.toLocaleString()}`,
      subtextStyle: { fontWeight: "bold", fontSize: "12px" },
    },
    color: ['#d1dc5a', '#e0f7e0', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'],
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        return (
          `<b>${params.name}</b><br/>` +
          `Puntos: <b>${params.value.toLocaleString()}</b> (${params.percent.toFixed(
            1
          )}%)<br/>` +
          `NFU: <b>${params.data.cantidad.toLocaleString()}</b>`
        );
      },
    },
    legend: {
      type: "scroll",
      orient: "horizontal",
      bottom: 10,
      left: "center",
      pageButtonPosition: "end",
      pageButtonItemGap: 5, 
      pageButtonGap: 5, 
      pageIconColor: "#333", 
      pageIconInactiveColor: "#aaa",
      pageIconSize: 15,
      pageTextStyle: { color: "#333" },
      formatter: function (name) {
        const item = mainSeriesData.find((i) => i.name === name);
        if (item) {
          return `${name}: ${item.value.toLocaleString()} puntos | ${item.cantidad.toLocaleString()} NFU`;
        }
        return name;
      },
      textStyle: {
        fontSize: 12,
      },
      itemWidth: 20, 
      itemGap: 15, 
    },
    series: [
      {
        name: "Puntos por categoría",
        type: "pie",
        radius: ["40%", "70%"],
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        data: mainSeriesData,
      },
    ],
  };

  const getSubCategoryOptions = (categoria) => {
    const subcategorias = categoriasData[categoria] || [];

    return {
      title: {
        text: `Subcategorías de ${categoria}`,
        left: "center",
        subtext: `PUNTOS: ${categorias[
          categoria
        ].toLocaleString()} | NFU: ${cantidadPorCategoria[
          categoria
        ].toLocaleString()}`,
        subtextStyle: { fontWeight: "bold", fontSize: "12px" },
      },
      color: ['#d1dc5a', '#e0f7e0', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'],
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          return (
            `<b>${params.name}</b><br/>` +
            `Puntos: <b>${params.value.toLocaleString()}</b> (${params.percent.toFixed(
              1
            )}%)<br/>` +
            `NFU: <b>${params.data.cantidad.toLocaleString()}</b>`
          );
        },
      },
      toolbox: {
        left: 10,
        top: 20,
        feature: {
          myTool: {
            show: true,
            title: "Volver",
            icon: "path://M44.8,12c-0.1,0-0.1,0-0.2,0h-29c-1,0-1.8,0.8-1.8,1.8c0,0.5,0.2,1,0.6,1.3l9.8,9.8c0.7,0.7,0.7,1.8,0,2.5 c-0.3,0.3-0.8,0.5-1.3,0.5s-0.9-0.2-1.3-0.5l-9.8-9.8C11,16.2,9.5,14.9,9.5,13c0-3.3,2.7-6,6-6h29c0.9,0,1.7,0.6,1.9,1.5 C46.6,9.4,46,10.4,44.8,12z",
            iconStyle: {
              color: "#000", 
              borderColor: "#000",
              borderWidth: 1,
            },
            onclick: function () {
              setCurrentView("main");
              setSelectedCategory(null);
            },
          },
        },
      },
      legend: {
        type: "scroll",
        orient: "horizontal",
        bottom: 10,
        left: "center",
        pageButtonPosition: "end",
        pageButtonItemGap: 5,
        pageButtonGap: 5,
        pageIconColor: "#333",
        pageIconInactiveColor: "#aaa",
        pageIconSize: 15,
        pageTextStyle: { color: "#333" },
        formatter: function (name) {
          const item = subcategorias.find((i) => i.name === name);
          if (item) {
            return `${name}: ${item.value.toLocaleString()} puntos | ${item.cantidad.toLocaleString()} NFU`;
          }
          return name;
        },
        textStyle: {
          fontSize: 12,
        },
        itemWidth: 20,
        itemGap: 15,
      },
      series: [
        {
          name: `Subcategorías de ${categoria}`,
          type: "pie",
          radius: ["30%", "70%"],
          center: ["50%", "45%"],
          roseType: "area",
          itemStyle: {
            borderRadius: 8,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: subcategorias,
        },
      ],
    };
  };

  const onChartEvents = {
    click: (params) => {
       
      if (params.seriesType === "pie" && params.data && params.data.name) {
         
        setSelectedCategory(params.data.name);
        setCurrentView("detail");
      }
    },
  };

  return (
    <div className="grafica-container">
      <EchartsWrapper
        key={`chart-${currentView}-${selectedCategory || "main"}`}
        options={
          currentView === "main"
            ? mainChartOptions
            : getSubCategoryOptions(selectedCategory)
        }
        onEvents={currentView === "main" ? onChartEvents : {}}
        style={{ width: "100%", height: "400px" }}
      />
    </div>
  );
};

export default PuntosCategoriaSubcategoria;
